import axios from 'axios';

const state = {
    cidades: [],
    estados: [],
    loaded: false
};

const getters = {};

const actions = {
    populateEstados ({ commit }) {
        axios.get(_ROOT_PATH + '/api/estados').then((data) => {
            commit('setEstados', data.data);
        });
    },
    populateCidades ({ commit }, estado) {
        axios.get(_ROOT_PATH + '/api/cidades/buscar', {params: {estado_id: estado}}).then((data) => {
            commit('setCidades', data.data);
        });
    }
};

const mutations = {
    setCidades (state, cidades) {
        state.cidades = cidades;
    },
    setEstados (state, estados) {
        state.estados = estados;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}